//Swish needs to be 32-chars and uppercase,

// NOTE! CANT GENERATE UUIDS IN COMMON.
// CRYPTO ISSUE WHEN IMPORTING LIBRARY IN NODE

const toSwishUUID = (string: string) => {
    return string.replace(/-/g, "").toUpperCase();
};

export { toSwishUUID };
